import { createSelector } from "reselect";
import { RootState } from "../../typings/mainState";
// TODO: remove "anys" from this file and replace them with the correct types
const powerSelector = (state: RootState) => (state.mainState ? state.mainState.powers : []);

export const powerAlreadyLoaded = createSelector([powerSelector], (powers) => !!powers.length);

const powersUserAndPlanSelector = (state: RootState) => {
  return state.mainState.powersUserAndPlan ? state.mainState.powersUserAndPlan : [];
};

// Workspace and Calendar Widget Dashboard
export const hasDashboardAccess = createSelector([powersUserAndPlanSelector], (powersUserAndPlan) =>
  powersUserAndPlan.includes("dashboardAccess")
);

export const hasOfficeDashboardAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasOfficeDashboardAccess")
);

export const hasStrategicManagementTabAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasStrategicManagementTabAccess")
);

export const hasLawsuitUpdatesCounterAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitUpdatesCounterAccess")
);

export const hasLawsuitUpdatesCounterCaseTypeFilterAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitUpdatesCounterCaseTypeFilterAccess")
);

export const hasLawsuitCounterAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitCounterAccess")
);

export const hasLawsuitCounterFilterAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitCounterFilterAccess")
);

export const hasLawsuitCounterComparisonStatAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitCounterComparisonStatAccess")
);

export const hasLateActivitiesCounterAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLateActivitiesCounterAccess")
);

export const hasLawsuitUpdatesRadarChartAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitUpdatesRadarChartAccess")
);

export const hasLawsuitTrackerLineChartAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitTrackerLineChartAccess")
);

export const hasLawsuitByCustomerOverTimeColumnChartAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasLawsuitByCustomerOverTimeColumnChartAccess")
);

export const hasActiveLawsuitsByResponsibleBarChartAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasActiveLawsuitsByResponsibleBarChartAccess")
);

export const hasDoneActivitiesByMonthStackedBarChartAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) =>
    powersUserAndPlan.includes("hasDoneActivitiesByMonthStackedBarChartAccessMinimumRange") ||
    powersUserAndPlan.includes("hasDoneActivitiesByMonthStackedBarChartAccessMediumRange") ||
    powersUserAndPlan.includes("hasDoneActivitiesByMonthStackedBarChartAccessMaximumRange")
);

export const hasDoneActivitiesByMonthStackedBarChartAccessMinimumRange = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) =>
    powersUserAndPlan.includes("hasDoneActivitiesByMonthStackedBarChartAccessMinimumRange")
);

export const hasDoneActivitiesByMonthStackedBarChartAccessMediumRange = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) =>
    powersUserAndPlan.includes("hasDoneActivitiesByMonthStackedBarChartAccessMediumRange")
);

export const hasDoneActivitiesByMonthStackedBarChartAccessMaximumRange = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) =>
    powersUserAndPlan.includes("hasDoneActivitiesByMonthStackedBarChartAccessMaximumRange")
);

export const hasInProgressActivitiesByResponsibleStackedColumnChartAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) =>
    powersUserAndPlan.includes("hasInProgressActivitiesByResponsibleStackedColumnChart")
);

export const hasDoneActivitiesByResponsibleLineChartAccess = createSelector(
  [powersUserAndPlanSelector],
  (powersUserAndPlan) => powersUserAndPlan.includes("hasDoneActivitiesByResponsibleLineChart")
);
